export default {
  ru: {
    content_1: "ЭЛЕКТРОПРОМРЕМОНТ",
    content_2: "ДВИГАТЕЛЬ ВАШЕГО БИЗНЕСА",
  },
  en: {
    content_1: "ELEKTROPROMREMONT",
    content_2: "ENGINE OF YOUR BUSINESS",
  },
  ua: {
    content_1: "ЕЛЕКТРОПРОМРЕМОНТ",
    content_2: "ДВИГУН ВАШОГО БІЗНЕСУ",
  }
}

